import { create } from 'zustand'
import type { Studio } from '@/shared/api/app-types'

type StudioState = {
  currentStudio: Studio | null
  setCurrentStudio: (studio: Studio | null) => void
}

/** Keeps the sidebar workspace label stable as AppShell remounts between routes. */
export const useStudioStore = create<StudioState>()((set) => ({
  currentStudio: null,
  setCurrentStudio: (currentStudio) => set({ currentStudio }),
}))
